export default __webpack_public_path__ + "84c1a652d7582cd83c70aed138cff4c8.png";